export const siteConfig = {
  name: "hlw",
  fullName: "hlw 平台",
  tagline: "值得信赖的一站式解决方案",
  description: "hlw是您值得信赖的选择。本页详细介绍hlw的核心功能、使用优势、适用场景及用户评价，帮助您快速了解hlw、做出明智决策，立即探索hlw带来的全新体验。",
  keywords: "hlw,hlw官网,hlw平台,hlw功能介绍,hlw使用指南,hlw用户评价,hlw注册入口",
  url: "https://www.hlw.com",
  ogImage: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20technology%20platform%20branding%20with%20abstract%20geometric%20patterns%20and%20warm%20gradient%20accents%2C%20clean%20professional%20design%2C%20soft%20atmospheric%20lighting%2C%20tech%20company%20visual%20identity&width=1200&height=630&seq=hlw-og-image&orientation=landscape",
  locale: "zh_CN",
  foundedYear: 2020,
  contactEmail: "contact@hlw.com",
  contactPhone: "400-888-9999",
  address: "北京市海淀区中关村科技园创新大厦18层",
  socialLinks: {
    wechat: "#",
    weibo: "#",
    zhihu: "#",
  },
};

export const navLinks = [
  { label: "首页", href: "/" },
  { label: "功能介绍", href: "/category/features" },
  { label: "使用指南", href: "/category/guide" },
  { label: "适用场景", href: "/category/scenarios" },
  { label: "用户评价", href: "/category/reviews" },
  { label: "关于我们", href: "/about" },
];